import { render, staticRenderFns } from "./VModalConfirm.vue?vue&type=template&id=143f5b59&"
import script from "./VModalConfirm.vue?vue&type=script&lang=ts&"
export * from "./VModalConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports